import { render, staticRenderFns } from "./AppNav.vue?vue&type=template&id=4fc9af78&scoped=true"
import script from "./AppNav.vue?vue&type=script&lang=js"
export * from "./AppNav.vue?vue&type=script&lang=js"
import style0 from "./AppNav.vue?vue&type=style&index=0&id=4fc9af78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc9af78",
  null
  
)

export default component.exports